module.exports = __webpack_public_path__ + "static/media/github.856e61fb.svg";